import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_components/Pagination/Pagination-Style2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageSkeleton"] */ "/app/src/app/_components/Skeleton/ImageSkeleton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/blog/components/Loading.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/blog/styles/page.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/blog/styles/BlogItem.module.css");
